<template>
  <div class="w-full flex gap-2 items-center flex-wrap">
    <niceone-image v-for="(image,index) in attachments" :key="index" :src="image" @click="show=true"
                   class="rounded-md h-[64px]" width="64"/>
    <van-image-preview
        v-model:show="show"
        :closeable="true"
        :images="attachments"
        dir="ltr"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  attachments: {
    type: Array,
    default: () => []
  }
})
const show = ref(false)

</script>

<style lang="scss" scoped>

</style>